import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { API_URL_CHECK_CUSTOMER_AND_SET_PERSONAL_DETAILS, FORM_ID } from "../../../../../constants";
import { RootState } from "../../../../../models";
import { CheckCustomerAndSetPersonalDetailsRequestBody } from "../../../../../models/actionPayloads";
import { CheckoutState, SubscriptionDetails } from "../../../../../models/state";
import { post } from "../../../app/Ajax";
import * as AT from "../../../checkout/state/actionTypes";
import * as FORM_SELECTORS from "../../../checkout/state/selectors/formSelectors";
import { VALIDATION_FIELD } from "../../../rapidform/formValidation";
import {
    API_URL_ONBOARDING_SET_SUBSCRIPTION_DETAILS,
    API_URL_ONBOARDING_SUBMIT_ORDER,
    API_URL_ONBOARDING_VERIFY_UPDATED_NAME,
} from "../../api";
import TEXT from "../../text-consts";
import {
    ONBOARDING_SET_SIM_TYPE,
    ONBOARDING_SET_SUBSCRIPTION_DETAILS,
    ONBOARDING_SUBMIT_ORDER,
    ONBOARDING_VERIFY_UPDATED_NAME,
} from "../actionTypes";
import * as ONBOARDING_SELECTORS from "../selectors";
import { getEmployeeInfo } from "../selectors";

export const addEmail = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch, getState) => {
    const state = getState();
    const { values } = ONBOARDING_SELECTORS.getEmailFormById(state, FORM_ID.ONBOARDING_EMAIL);
    const phone = getEmployeeInfo(state)?.phonenumber as string;
    const email = values.details[VALIDATION_FIELD.PRODUCT_USER_EMAIL];
    const personalDetailsContainer: CheckCustomerAndSetPersonalDetailsRequestBody = {
        // @ts-expect-error: personalData contains any-values
        personalData: null,
        extraPersonalData: {
            email,
            phone,
        },
    };

    // Call setPersonalDetails API endpoint
    const response = post<CheckoutState>(
        {
            url: API_URL_CHECK_CUSTOMER_AND_SET_PERSONAL_DETAILS,
            data: personalDetailsContainer,
        },
        dispatch,
    ).then(({ cart, subscriptions }) => ({
        success: true,
        cart,
        subscriptions,
    }));

    return dispatch({
        type: AT.CHECKOUT_SET_PERSONAL_DETAILS,
        payload: response,
        meta: {
            flashOnError: {
                defaultErrorMessage: TEXT.ONBOARDING_B2B.ERROR.ORDER_SUBMIT,
            },
        },
    });
};

export const setIsEsim =
    (isEsim: boolean): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        return dispatch({
            type: ONBOARDING_SET_SIM_TYPE,
            payload: isEsim,
        });
    };

export const setSubscriptionDetails =
    (data: Partial<SubscriptionDetails>): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch, getState) => {
        const state = getState();
        const { values } = FORM_SELECTORS.getFormById(state, FORM_ID.ADD_MEMBER);
        const customerType = ONBOARDING_SELECTORS.getSubscriptionDetails(state).check.type || values.member.type;
        const isEsimSelected = ONBOARDING_SELECTORS.isEsimSelected(state);
        const phonenumber = values.member.number.replace(/\s/g, "");

        const subscriptionDetails = { ...data, phonenumber, customerType, isEsimSelected };
        return dispatch({
            type: ONBOARDING_SET_SUBSCRIPTION_DETAILS,
            payload: post<{ status: string }>(
                {
                    url: API_URL_ONBOARDING_SET_SUBSCRIPTION_DETAILS,
                    data: {
                        subscriptionDetails,
                    },
                },
                dispatch,
            ),
        });
    };

export const submitOrder = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch) => {
    return dispatch({
        type: ONBOARDING_SUBMIT_ORDER,
        payload: post<{ status: string }>(
            {
                url: API_URL_ONBOARDING_SUBMIT_ORDER,
            },
            dispatch,
        ),
    });
};

export const verifyUpdatedName =
    (updatedFirstName: string, updatedLastName: string): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        const payload = post(
            {
                url: API_URL_ONBOARDING_VERIFY_UPDATED_NAME,
                data: {
                    updatedFirstName,
                    updatedLastName,
                },
            },
            dispatch,
        );
        dispatch({
            type: ONBOARDING_VERIFY_UPDATED_NAME,
            payload,
        });
        return payload;
    };
